import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import '@xyflow/react/dist/style.css';
import './index.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('找不到 #root 挂载点，请检查 index.html 是否被改动');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
